import { render, staticRenderFns } from "./monthly_area_brand.vue?vue&type=template&id=2e4632fc&scoped=true"
import script from "./monthly_area_brand.vue?vue&type=script&lang=js"
export * from "./monthly_area_brand.vue?vue&type=script&lang=js"
import style0 from "./monthly_area_brand.vue?vue&type=style&index=0&id=2e4632fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4632fc",
  null
  
)

export default component.exports